import type { EventCategory } from "@cdt/shared";
import { Pencil, Trash2 } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

interface CategoriesTableProps {
  items: EventCategory[];
  deletingId: string | null;
  onEdit: (item: EventCategory) => void;
  onDelete: (item: EventCategory) => void;
}

export function CategoriesTable({
  items,
  deletingId,
  onEdit,
  onDelete,
}: CategoriesTableProps) {
  return (
    <div className="rounded-lg border bg-card">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Nome</TableHead>
            <TableHead>Colore Outlook</TableHead>
            <TableHead>Stato</TableHead>
            <TableHead className="text-right">Azioni</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.map((item) => (
            <TableRow key={item.id}>
              <TableCell>
                <div className="font-medium">{item.name}</div>
                {item.description ? (
                  <div className="mt-0.5 text-xs text-muted-foreground">{item.description}</div>
                ) : null}
              </TableCell>
              <TableCell>
                <span className="text-xs text-muted-foreground">{item.outlookColor}</span>
              </TableCell>
              <TableCell>
                <Badge variant={item.isActive ? "green" : "gray"}>
                  {item.isActive ? "Attiva" : "Disattivata"}
                </Badge>
              </TableCell>
              <TableCell className="text-right">
                <div className="inline-flex gap-2">
                  <Button
                    variant="outline"
                    size="sm"
                    type="button"
                    onClick={() => onEdit(item)}
                  >
                    <Pencil className="h-3.5 w-3.5" />
                    Modifica
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    type="button"
                    onClick={() => onDelete(item)}
                    disabled={deletingId === item.id}
                  >
                    <Trash2 className="h-3.5 w-3.5" />
                    Elimina
                  </Button>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
